import baselineOnboardingRoutes from '@/pages/baseline/onboarding/routes'
import type { ABTestRouteConfig } from '@app-studio-web/ui/types/abtest'

/**
 * A/B Test Configuration for GlowMinder
 *
 * Each variant uses a different URL path prefix:
 * - Baseline: /onboarding/{page} (formerly v1 - winner of previous A/B test)
 * - Future variants: /onboarding/v2/{page}, etc.
 *
 * Variant assignment is maintained via Confidence cookie across refreshes
 */

// Helper to map onboardingRoutes definitions to an ordered list of child paths
// function extractChildPaths(onboardingRoutesDef: any[]): string[] {
//   const parent = onboardingRoutesDef[0]
//   if (!parent || !parent.children) return []
//   return parent.children.map((child: any) => child.path)
// }

// Note: baselineOnboardingRoutes is now a flat array, not nested
// So we just map to extract paths directly
const baselineOrder = baselineOnboardingRoutes
  .map((route: { path?: string }) => route.path)
  .filter((path): path is string => !!path)

export const glowMinderABTestRouteConfig: ABTestRouteConfig = {
  baseline: baselineOrder,
  variants: {
    // Future variants will be added here (e.g., v2, v3)
  },
}

/**
 * Get A/B test configuration from environment variables
 */
export function getABTestConfig() {
  const clientSecret = import.meta.env.VITE_CONFIDENCE_CLIENT_SECRET as string
  const flagName =
    (import.meta.env.VITE_CONFIDENCE_FLAG_NAME as string) ||
    'glowminder-onboarding-variant'

  // Only enable A/B testing if client secret is provided
  if (!clientSecret) {
    console.warn('No Confidence client secret provided, A/B testing disabled')
    return null
  }

  return {
    clientSecret,
    flagName,
    defaultVariant: 'baseline',
    enabledVariants: ['baseline'], // Only baseline for now; v1 became the new baseline
    // For testing future variants:
    // enabledVariants: ['baseline', 'v2'],
  }
}
